import React, { useMemo } from 'react'
import { Chip, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FeedbackData } from '@/redux/ducks/ai/chat'
import lang from '@/lang'

const useStyles = makeStyles(() => ({
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    minWidth: 200,
  },
  tooltipTags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 4,
  },
  tooltipTag: {
    fontSize: 11,
    height: 22,
  },
}))

interface AiFeedbackTooltipProps {
  submittedFeedback: FeedbackData
}

export default function AiFeedbackTooltip(props: AiFeedbackTooltipProps) {
  const classes = useStyles()
  const { submittedFeedback } = props

  const content = useMemo(() => {
    if (!submittedFeedback.tags.length && !submittedFeedback.comment) {
      return (
        <Typography variant="body2">{lang.ai.chat.feedback.tooltip.noDetailedFeedback}</Typography>
      )
    }

    return (
      <>
        {submittedFeedback.tags.length > 0 && (
          <div>
            <Typography variant="body2" fontWeight={600}>Tags:</Typography>
            <div className={classes.tooltipTags}>
              {submittedFeedback.tags.map(tag => (
                <Chip key={tag} label={tag} size="small" className={classes.tooltipTag} />
              ))}
            </div>
          </div>
        )}
        {submittedFeedback.comment && (
          <div>
            <Typography variant="body2" fontWeight={600}>Kommentar:</Typography>
            <Typography variant="body2">{submittedFeedback.comment}</Typography>
          </div>
        )}
      </>
    )
  }, [submittedFeedback])

  return (
    <div className={classes.tooltipContent}>
      {content}
    </div>
  )
}
